const CeoLandingPanel = ({ projectedRevenueLabel, deltaLabel }) => {
  if (!projectedRevenueLabel || !deltaLabel) {
    return null;
  }

  return (
    <section
      className="rounded-3xl border border-white/10 glass p-6"
      data-testid="pilotage-objectives-ceo-landing"
      aria-labelledby="pilotage-objectives-ceo-landing-title"
    >
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        Projection fin d'annee
      </p>
      <h2 id="pilotage-objectives-ceo-landing-title" className="mt-2 text-xl font-heading font-semibold text-white">
        Atterrissage
      </h2>
      <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <article className="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">CA net projete fin d'annee</p>
          <p className="mt-3 text-2xl font-semibold text-white">{projectedRevenueLabel}</p>
          <p className="mt-2 text-sm text-slate-300">{deltaLabel}</p>
        </article>
      </div>
    </section>
  );
};

export default CeoLandingPanel;
